/* unplugin-vue-components disabled */import { render } from "./MinerOverview.vue?vue&type=template&id=6196a1f1&scoped=true"
import script from "./MinerOverview.vue?vue&type=script&lang=js"
export * from "./MinerOverview.vue?vue&type=script&lang=js"

import "./MinerOverview.vue?vue&type=style&index=0&id=6196a1f1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6196a1f1"]])

export default __exports__